/* eslint-disable import/order */
import { globalAdminPrioritySchemesEntryPoint } from '@jira/admin-pages__priority-schemes/src/globalAdminPrioritySchemesEntryPoint.entrypoint.tsx';
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalIssuesSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalIssuesSettings.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { globalSettingsIssuesPrioritySchemesRoute } from '@jira/router-routes__admin-pages-priorities-routes/src/globalSettingsIssuesPrioritySchemesRoute.tsx';
import { conditionalPostOfficeJiraTopBannerResource } from '@jira/router-resources__post-office/src/conditionalPostOfficeJiraTopBannerResource.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import PrioritySchemes, {
	LazyPrioritySchemes,
} from './ui/spa/admin-pages/priorities/priority-schemes/index.tsx';

const globalSettingsIssuesPrioritySchemesRouteEntryPointPage = createPageEntryPoint({
	main: globalAdminPrioritySchemesEntryPoint,
});

export const globalSettingsIssuesPrioritySchemesRouteEntry: Route = createEntry(
	globalSettingsIssuesPrioritySchemesRoute,
	() => ({
		group: 'global-settings',
		// eslint-disable-next-line no-restricted-syntax
		component: PrioritySchemes,
		layout: globalSettingsLayout,

		entryPoint: () =>
			fg('eax-1638_priorities_page_route_to_use_entrypoint')
				? globalSettingsIssuesPrioritySchemesRouteEntryPointPage
				: undefined,

		navigation: {
			sidebarId: SidebarIdGlobalIssuesSettings,
			menuId: MenuIdSettings,
		},

		resources: [
			...getNavigationResources(),
			navigationSidebarGlobalResource,
			conditionalPostOfficeJiraTopBannerResource,
		],

		forPaint: [LazyPrioritySchemes],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
